[
  {
    "id": "en",
    "title": "EN",
    "flag": "gb"
  },
  {
    "id": "de",
    "title": "DE",
    "flag": "de"
  },
  {
    "id": "fr",
    "title": "FR",
    "flag": "fr"
  },
  {
    "id": "sq",
    "title": "SQ",
    "flag": "al"
  }
]
